import assignWith from 'lodash/assignWith';
import join from 'lodash/join';

function nullifyIfEmptyStringCustomizer(objValue: any, srcValue: string) {
  return srcValue === '' ? null : objValue;
}

/**
 * Sets data attributes to null if they are an empty string
 * @param  {Object} params API payload params
 * @return {Object}        Mutated API payload params.
 */
export function nullifyEmptyStringAttributes(params = {}) {
  if (params?.data?.attributes) {
    params.data.attributes = assignWith({}, params.data.attributes, nullifyIfEmptyStringCustomizer);
  }
  return params;
}

export function parseIncludes(includes: string[]) {
  return join(includes, ',');
}
